import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FolderOpen, PlusCircle, ChevronRight } from "lucide-react";
import { api } from "../lib/api";

const typeLabels = { utenze: "Utenze", credito: "Credito", assicurazioni: "Assicurazioni" };
const typeColors = { utenze: "#10B981", credito: "#0A192F", assicurazioni: "#F97316" };
const statusLabels = { ricevuta: "Ricevuta", in_lavorazione: "In lavorazione", completata: "Completata" };

export default function Pratiche() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/requests").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="pratiche-page" className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-bold text-[#0A192F]">Le tue pratiche</h1>
          <p className="mt-1 text-slate-600">Tutte le richieste che hai aperto.</p>
        </div>
        <Link to="/area/richieste" data-testid="pratiche-new-btn" className="hidden items-center gap-2 rounded-full bg-[#10B981] px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#059669] sm:flex">
          <PlusCircle className="h-4 w-4" /> Nuova richiesta
        </Link>
      </div>

      {items === null ? (
        <div className="py-20 text-center text-slate-400">Caricamento...</div>
      ) : items.length === 0 ? (
        <div data-testid="pratiche-empty" className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 text-center">
          <FolderOpen className="mx-auto h-10 w-10 text-slate-300" />
          <p className="mt-4 font-semibold text-[#0A192F]">Nessuna pratica ancora</p>
          <p className="mt-1 text-sm text-slate-500">Apri la tua prima richiesta per iniziare.</p>
          <Link to="/area/richieste" className="mt-6 inline-block rounded-full bg-[#10B981] px-6 py-2.5 text-sm font-semibold text-white">Apri una richiesta</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((it) => (
            <div key={it.id} data-testid={`pratica-${it.id}`} onClick={() => navigate(`/area/pratiche/${it.id}`)} className="flex cursor-pointer flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-6 transition-colors hover:border-[#10B981] sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-start gap-4">
                <span className="mt-0.5 rounded-full px-3 py-1 text-xs font-bold text-white" style={{ backgroundColor: typeColors[it.type] || "#0A192F" }}>
                  {it.category || typeLabels[it.type] || it.type}
                </span>
                <div>
                  <p className="font-display font-bold text-[#0A192F]">{it.title}</p>
                  <p className="text-sm text-slate-500">{it.subcategory}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">
                  {statusLabels[it.status] || it.status}
                </span>
                <span className="text-xs text-slate-400">{new Date(it.created_at).toLocaleDateString("it-IT")}</span>
                <ChevronRight className="h-4 w-4 text-slate-300" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
